'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PictureModal = require('./PictureModal');

var _PictureModal2 = _interopRequireDefault(_PictureModal);

var _files = require('../lib/files');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileInput = function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput(props) {
    _classCallCheck(this, FileInput);

    var _this = _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call(this, props));

    _this.state = {
      shouldShowModal: false
    };
    return _this;
  }

  _createClass(FileInput, [{
    key: 'onImageClick',
    value: function onImageClick() {
      this.setState({ shouldShowModal: true });
    }
  }, {
    key: 'onModalHide',
    value: function onModalHide() {
      this.setState({ shouldShowModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          files = _props.files,
          filesUrls = _props.filesUrls,
          extraData = _props.extraData,
          _onDrop = _props.onDrop,
          onRemove = _props.onRemove;
      var backgroundSize = extraData.backgroundSize;


      var file = files && files[item.name] || filesUrls && filesUrls[item.name] || {};

      var filename = file.name || (0, _files.getFilename)(file);

      var fileIsImage = (0, _files.isImage)(filename);

      var dropzone = void 0;

      var match2 = /\.([a-z]+)$/.exec(filename);

      var extension = match2 && match2[1];

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('ui', 'input', 'inputItem', 'fileInputItem', {
            placeholder: !filename
          })
        },
        !(file || {}).preview && _react2.default.createElement(_reactDropzone2.default, {
          ref: function ref(c) {
            dropzone = c;
          },
          onDrop: function onDrop(droppedFiles) {
            _onDrop(item.name, droppedFiles[0]);
          },
          style: { display: 'none' }
        }),
        filename && _react2.default.createElement(
          'div',
          { className: 'removeFileButton', onClick: function onClick() {
              onRemove(item.name, file);
            } },
          _react2.default.createElement('i', { className: 'remove icon' })
        ),
        filename && fileIsImage && _react2.default.createElement('div', {
          className: 'filePreview imagePreview',
          onClick: this.onImageClick.bind(this),
          style: {
            backgroundImage: 'url("' + (file.preview || file) + '")',
            backgroundSize: backgroundSize || 'auto 100%'
          }
        }),
        filename && fileIsImage && backgroundSize && _react2.default.createElement(_PictureModal2.default, {
          shouldShowModal: this.state.shouldShowModal,
          onModalHide: this.onModalHide.bind(this),
          file: file
        }),
        filename && !fileIsImage && _react2.default.createElement(
          'div',
          { className: 'filePreview' },
          _react2.default.createElement(
            'div',
            null,
            filename
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('i', { className: (0, _classnames2.default)('file', extension, 'outline', 'icon') })
          )
        ),
        !filename && _react2.default.createElement(
          'div',
          { className: 'filePlaceholderContainer', onClick: function onClick() {
              dropzone.open();
            } },
          _react2.default.createElement(
            'div',
            { className: 'filePlaceholder' },
            'Seleziona un file',
            _react2.default.createElement('i', { className: 'plus icon' })
          )
        )
      );
    }
  }]);

  return FileInput;
}(_react.Component);

;

FileInput.propTypes = {
  item: _propTypes2.default.object.isRequired,
  files: _propTypes2.default.object.isRequired,
  filesUrls: _propTypes2.default.object.isRequired,
  onDrop: _propTypes2.default.func.isRequired,
  onRemove: _propTypes2.default.func.isRequired
};

exports.default = FileInput;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/FileInput.js
// module id = 158
// module chunks = 0